// extracted by mini-css-extract-plugin
export default {"list":"aGoOAc","li":"bGoOAc","external":"cGoOAc","searchItem":"dGoOAc","img":"eGoOAc","textContainer":"fGoOAc","icon":"gGoOAc"};